/*
 * 关系阶段徽标。
 *
 * **组件内不计算规则。** 阶段名（朋友 / 好友 / 密友 / 知己 / 挚友）与阈值由服务端
 * 裁定后下发，前端只负责画。旧项目在 MyReputation.tsx 里内联了
 * `100 / 1000 / 10000 / 100000 / 1000000` 五档阈值，服务端一改前端就静默错位。
 *
 * 拿不到阶段时显示未知态，而不是回落到「朋友」——那会让一个刚认识的用户
 * 看到自己已经是朋友，也会让一个知己被降级。
 */

import { IconHeart } from "./Icons";

export interface RelationshipStageView {
  /** 服务端下发的阶段名。 */
  label: string;
  /** 可选的阶段说明，同样由服务端下发。 */
  hint?: string;
}

export function RelationshipBadge({
  stage,
  unavailableReason,
}: {
  stage?: RelationshipStageView | null;
  unavailableReason?: string;
}) {
  if (!stage) {
    return (
      <span
        className="rel-badge rel-badge--unknown"
        title={unavailableReason ?? "关系阶段读取不到"}
      >
        <IconHeart size={13} />
        <span className="rel-badge__dash" />
      </span>
    );
  }

  return (
    <span className="rel-badge" title={stage.hint ?? undefined}>
      <IconHeart size={13} />
      <span>{stage.label}</span>
    </span>
  );
}
